import { useTranslation } from '@/lib/i18n/i18n.client';

import Button from '../../atoms/Button';

type PaginationProps = {
  label: string;
  loading: boolean;
  onLoadMore: () => void;
};

export function Pagination({ label, loading, onLoadMore }: PaginationProps) {
  const { texts } = useTranslation();

  return (
    <Button
      onClick={() => onLoadMore()}
      disabled={loading}
      variant='outlined'
      color='secondary'
      fullwidth
    >
      {loading ? texts.service_status.loading : label}
    </Button>
  );
}
